import {
  SimpleForm,
  SimpleFormIterator,
  ReferenceInput,
  TextInput,
  AutocompleteInput,
  ArrayInput
} from "react-admin";
import React from "react";
import { required } from "../../services/validate";

const GroupForm = props => {
  return (
    <SimpleForm {...props}>
      <TextInput source="name" validate={[required()]} />
      <ArrayInput source="users">
        <SimpleFormIterator>
          <ReferenceInput
            label="Email"
            source="id"
            reference="user"
            validate={[required()]}
          >
            <AutocompleteInput
              source="email"
              optionText={value => `${value.email} ${value.provider || ""}`}
            />
          </ReferenceInput>
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  );
};

export default GroupForm;



// WEBPACK FOOTER //
// ./src/components/group/GroupForm.js